import {nanoid} from 'nanoid'
import barba from '@barba/core';

import './Factory'
import Z from '@/js/Z';

import StickyMove from '@/js/modules/StickyMove'

// keep SPA important static elements references
let $navbar, pageTitleElement, navbarModule;

class App {
	constructor() {
		App.appId = nanoid();
		this.createSPA();
		Z.init(this);
		this.setLayout();
	}

	init() {
		MODULE.init();
		$navbar = $('#navbar');
		pageTitleElement = $('.pageTitle>h1');
		navbarModule = MODULE.getByNameEl('NavBar', $navbar);
		StickyMove.start();
	}

	// barba enters page data.next.container is the new/entering container
	enter(data) {
		let {container} = data.next,
			$el = $(container),
			hasHeader = $el.children('header').length > 0;
		let newBodyTag = data.next.html.match(/<body .+?>/g)[0],
			newBodyClass = newBodyTag.match(/class="(.*?)"/i)[1];
		Z.$body.removeAttr('class').addClass(newBodyClass);
		MODULE.init($el);
		StickyMove.start();
		$navbar.toggleClass('expandable', hasHeader);
		if (hasHeader) navbarModule.onAppScroll();
		$('#navbarToggle').removeClass('show');
		$('#navbarToggler').removeClass('show');
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and

		// As navbar is inside wrapper, but outside of the container, update
		// relevant DOM to new container content.
		this.setLayout($el.data('pageTitle'));
	}

	setLayout(pageTitle) {
		let isHome = Z.isHome();
		$navbar.toggleClass('homepage', isHome);
		$('.show-on-home').toggle(isHome);
		$('.hide-on-home').toggle(!isHome);

		if (pageTitle) {
			pageTitleElement.text(pageTitle);
		}
	}

	// barba leave page data.current.container is the old/leaving container
	leave(data) {
		MODULE.destroy($(data.current.container));
		StickyMove.destroy();
	}

	// Uses barba.js to create SPA
	createSPA() {
		barba.init({
			prefetchIgnore: true,
			timeout: 10000,
			transitions: [{
				leave: data => this.leave(data),
				enter: data => this.enter(data)
			}]
		});
	}
}

new App;


